<div *ngIf="customer">
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-customer-info.customer' | translate }} #</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ customer.CrmId }}</span>
      </p>
    </div>
  </div>
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-customer-info.customer-name' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ customer?.Name }}</span>
      </p>
    </div>
  </div>
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-customer-info.address' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ customer?.Address }}</span>
      </p>
    </div>
  </div>
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-customer-info.city' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ customer?.City }}</span>
      </p>
    </div>
  </div>
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-customer-info.country' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ customer?.Country | country | async }}</span>
      </p>
    </div>
  </div>
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-customer-info.localEntity' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ customer?.LocalEntity | localEntity }}</span>
      </p>
    </div>
  </div>
  <div class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-customer-info.languages' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ customer?.Language | languages }}</span>
      </p>
    </div>
  </div>
  <div class="ir-row" *ngFor="let order of customer?.MachineSalesOrder; first as isFirst">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p *ngIf="isFirst">
        <span
          ><strong>{{ 'plugins.installation-customer-info.machine-sales-order' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span>{{ order }}</span>
      </p>
    </div>
  </div>
</div>
